export default {
  en: {
    bannerTariff: 'You already have annual subscription.',
    titleTopBlock1: 'Practice with us and improve your',
    titleTopBlock2: ' game ',
    titleTopBlock3: 'skills.',
    textTopBlock: 'OmahaPro is a Pot Limit Omaha training site. Here you will find information on preflop and you can consolidate your knowledge in the simulator. Preflop will help you understand PLO ranges better, and Training will help you reinforce that knowledge.',
  },
  ru: {
    bannerTariff: 'У вас уже есть годовая подписка.',
    titleTopBlock1: 'Тренируйся с нами и повысь свой',
    titleTopBlock2: ' уровень ',
    titleTopBlock3: 'игры.',
    textTopBlock: 'OmahaPro - это обучающий сайт по пот-лимит омахе. Здесь вы найдете информацию по префлопу и сможете закрепить знания в  тренажере. Preflop поможет вам лучше понять диапазоны в PLO, а Training поможет вам закрепить эти знания.',
  },
};
